import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tooltip,
} from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ExpenseStatus, expenseStatusKorean } from '../../modules/expenses';
import { ClearOutlined, SearchOutlined } from '@ant-design/icons';

const { Option } = Select;

const StyledDiv = styled.div`
  .ant-picker-input.ant-input {
    width: 100%;
  }
`;

interface SearchExpenseComponentProps {
  expenseCommon: any;
  searchData: any;
  searchExpenses: (data: any) => void;
  initSearchForm: () => void;
}
function SearchExpenseComponent({
  expenseCommon,
  searchData,
  searchExpenses,
  initSearchForm,
}: SearchExpenseComponentProps) {
  const [form] = Form.useForm();
  const dateFormat = 'YYYY-MM-DD';

  const [memberListOptions, setMemberListOptions] = useState<any>();
  const [categoryListOptions, setCategoryListOptions] = useState<any>();
  const [projectListOptions, setProjectListOptions] = useState<any>();

  useEffect(() => {
    let children: any = [];
    children.push(
      <Option key={null} value={-1}>
        {'모든직원'}
      </Option>,
    );
    for (const member of expenseCommon.memberList) {
      children.push(
        <Option key={member.value} value={member.value}>
          {member.name}
        </Option>,
      );
    }
    setMemberListOptions(children);
    children = [];
    children.push(
      <Option key={null} value={''}>
        {'모든 카테고리'}
      </Option>,
    );
    for (const category of expenseCommon.categoryList) {
      children.push(
        <Option key={category.value} value={category.name}>
          {category.name}
        </Option>,
      );
    }
    setCategoryListOptions(children);

    children = [];
    children.push(
      <Option key={null} value={-1}>
        {'모든 프로젝트'}
      </Option>,
    );
    for (const project of expenseCommon.projectList.sort((a: any, b: any) =>
      b.startDate.localeCompare(a.startDate),
    )) {
      children.push(
        <Option key={project.id} value={project.id}>
          <Tooltip
            title={`${project.name}(${project.startDate} ~ ${project.endDate})`}
          >
            <span>{project.name}</span>
          </Tooltip>
        </Option>,
      );
    }
    setProjectListOptions(children);
  }, [expenseCommon]);

  useEffect(() => {
    if (searchData) {
      form.setFieldsValue({ ...searchData });
    }
  }, [searchData, form]);

  return (
    <StyledDiv>
      <Form
        form={form}
        layout="vertical"
        onFinish={searchExpenses}
        initialValues={searchData}
        style={{ border: '2px solid #bcbcbc', marginRight: '10px' }}
      >
        <Row justify="center" style={{ marginTop: '20px' }}>
          <Form.Item>
            <Space size="middle">
              <Button
                htmlType="button"
                onClick={initSearchForm}
                size="small"
                icon={<ClearOutlined rev={undefined} />}
              >
                초기화
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                size="small"
                icon={<SearchOutlined rev={undefined} />}
              >
                검색
              </Button>
            </Space>
          </Form.Item>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item
              name="startDate"
              label="시작일"
              rules={[
                {
                  required: true,
                  message: '시작일을 선택해 주세요.',
                },
              ]}
            >
              <DatePicker format={dateFormat} style={{ width: '180px' }} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item
              name="endDate"
              label="종료일"
              rules={[
                {
                  required: true,
                  message: '종료일을 선택해 주세요.',
                },
              ]}
            >
              <DatePicker format={dateFormat} style={{ width: '180px' }} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item name="expenseStatus" label="상태">
              <Select style={{ width: '180px' }}>
                {/* <Option
                  key={ExpenseStatus.PROCESSING}
                  value={ExpenseStatus.PROCESSING}
                >
                  {expenseStatusKorean[ExpenseStatus.PROCESSING]}
                </Option> */}
                <Option
                  key={ExpenseStatus.EDITING}
                  value={ExpenseStatus.EDITING}
                >
                  {expenseStatusKorean[ExpenseStatus.EDITING]}
                </Option>
                <Option
                  key={ExpenseStatus.SUBMITTED}
                  value={ExpenseStatus.SUBMITTED}
                >
                  {expenseStatusKorean[ExpenseStatus.SUBMITTED]}
                </Option>
                {/* <Option
                  key={ExpenseStatus.DECLINED}
                  value={ExpenseStatus.DECLINED}
                >
                  {expenseStatusKorean[ExpenseStatus.DECLINED]}
                </Option> */}
                <Option
                  key={ExpenseStatus.EXCLUDED}
                  value={ExpenseStatus.EXCLUDED}
                >
                  {expenseStatusKorean[ExpenseStatus.EXCLUDED]}
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item name="project" label="프로젝트">
              <Select style={{ width: '180px' }}>{projectListOptions}</Select>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item name="companyName" label="상호명">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item name="member" label="직원">
              <Select style={{ width: '180px' }}>{memberListOptions}</Select>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item name="category" label="용도">
              <Select style={{ width: '180px' }}>{categoryListOptions}</Select>
            </Form.Item>
          </Col>
        </Row>
        {/* <Row justify="center">
          <Col>
            <Form.Item name={'assetType'} label="종류">
              <Select style={{ width: '180px' }}>
                <Option key={null} value={''}>
                  {'전부'}
                </Option>
                <Option key={AssetType.CARD} value={AssetType.CARD}>
                  {'카드'}
                </Option>
                <Option key={AssetType.TAX} value={AssetType.TAX}>
                  {'세금계산서'}
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row> */}
        <Row justify="center">
          <Col>
            <Form.Item name="isRefund" label="경비환급">
              <Select style={{ width: '180px' }}>
                <Option key={null} value={''}>
                  전부
                </Option>
                <Option value={true}>예</Option>
                <Option value={false}>아니오</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledDiv>
  );
}

export default SearchExpenseComponent;
